const axios = require("axios");

function getUserImpersonateUrl(user_id) {
  const customConfig = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem("pub_id")
    }
  };

  return axios
    .get( process.env.REACT_APP_API_SERVER_HOST + `/user/impersonate/${user_id}`, customConfig)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return [];
    });
}

export const service = {
  getUserImpersonateUrl
};